import React from 'react';
import PropTypes from 'prop-types';
import NumericQuestion from './NumericQuestion';
import { questionTypes } from '../../../constants/questionnaires';
import YesNoQuestion from './YesNoQuestion';
import SelectorQuestion from './SelectorQuestion';

const QuestionByType = ({ type, ...props }) => {
  switch (type) {
    case questionTypes.NUMERIC: return <NumericQuestion {...props} />;
    case questionTypes.YESNO: return <YesNoQuestion {...props} />;
    case questionTypes.SELECTION: return <SelectorQuestion {...props} />;
    default: return null;
  }
};

QuestionByType.propTypes = {
  type: PropTypes.string,
};

export default QuestionByType;
